var map = {
	"./anf-default.svg": 59096,
	"./aws-default.svg": 86806,
	"./azure-default.svg": 84143,
	"./azure_data_lake-default.svg": 30903,
	"./box-default.svg": 22061,
	"./cifs-default.svg": 45309,
	"./cvo-default.svg": 61847,
	"./cvs-default.svg": 76061,
	"./data-broker-default.svg": 50547,
	"./directory-default.svg": 7171,
	"./efs-default.svg": 59192,
	"./file-server-default.svg": 1070,
	"./fsx-default.svg": 16289,
	"./gcp-default.svg": 64363,
	"./gdrive-default.svg": 33376,
	"./ibm-default.svg": 63927,
	"./nfs-default.svg": 6697,
	"./onprem-default.svg": 63341,
	"./ontap-default.svg": 58590,
	"./s3-default.svg": 17630,
	"./sftp-default.svg": 8674,
	"./sgws-default.svg": 99297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82928;